import React, { useState, useCallback } from 'react';
import { Copy, Check } from 'lucide-react';
import { button, cn } from '../ui/uiTheme';
import { githubCloneUrl } from './repoViewTheme';

export default function CloneUrlBar({ htmlUrl, url: urlProp, className = '' }: any) {
  const url = urlProp || githubCloneUrl(htmlUrl);
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  }, [url]);

  if (!url) return null;

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-2 rounded-lg border border-dark-border bg-dark-base px-3 py-2 font-mono text-sm text-slate-300',
        className
      )}
    >
      <span className="min-w-0 truncate" title={url}>
        {url}
      </span>
      <button
        type="button"
        onClick={handleCopy}
        className={cn(button.icon, 'h-8 w-8 shrink-0')}
        aria-label={copied ? 'Copied' : 'Copy clone URL'}
      >
        {copied ? (
          <Check className="h-4 w-4 text-emerald-400" aria-hidden />
        ) : (
          <Copy className="h-4 w-4" aria-hidden />
        )}
      </button>
    </div>
  );
}
